// Maps a failed-login HTTP status to a clear, professional, user-facing message so people can tell
// a wrong password (401) apart from an access problem (403), rate limiting (429), or a temporary
// server issue (5xx). Used by the partner/Jobcase login forms. The status is surfaced by the
// browser-side auth service (authPartners.js); this does not affect the gateway endpoint or
// programmatic clients.
export const getLoginErrorMessage = (status) => {
   switch (status) {
      case 401:
         return 'The email or password you entered is incorrect. Please try again.';
      case 403:
         return 'This account does not have access to the partner portal. Please contact your administrator if you believe this is a mistake.';
      case 429:
         return 'Too many sign-in attempts. Please wait a moment and try again.';
      case 500:
      case 502:
      case 503:
      case 504:
         return 'We are having trouble signing you in right now. Please try again in a few minutes.';
      default:
         return 'We were unable to sign you in. Please try again in a moment.';
   }
};
